import React from 'react';
import { Link } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { aemPdfLinks } from './Links';

export const FPSPhoneNumbers = {
    serviceErrorNumber: `1-888-358-8490`,
    fpsSupportNumber: `1-888-358-8490`,
};

export const errorText = (
    <div style={{ fontSize: '16px', lineHeight: '22px' }}>
        If the problem continues, call{' '}
        <Link
            href={`tel:+${FPSPhoneNumbers.serviceErrorNumber}`}
            sx={{
                textDecoration: 'none',
                '&:hover': {
                    textDecoration: 'underline',
                },
            }}
        >
            {FPSPhoneNumbers.serviceErrorNumber}
        </Link>{' '}
        for technical support. Available weekdays, 8 a.m. to 8 p.m. ET.
    </div>
);

export const consentUrls = ['/client-consent', '/client-consent-reenroll', '/co-client-consent', '/co-client-consent-reenroll', '/', ''];

export const coClientConsentUrls = [
    '/usis/advice/fps/co-client-consent',
    '/usis/advice/fps/co-client-consent/',
    '/usis/advice/fps/co-client-consent-reenroll/',
    '/usis/advice/fps/co-client-consent-reenroll',
];

export const reenrollUrls = [
    '/usis/advice/fps/co-client-consent-reenroll',
    '/usis/advice/fps/co-client-consent-reenroll/',
]


export const clientConsentUrls = [
    '/usis/advice/fps/client-consent-reenroll',
]


export const clientTypeFPS = {
    'CLIENT': 'PRIMARY',
    'COCLIENT': 'COCLIENT'
};


export const lrnNumber = '202409-3888160';
export const footerDisc = `<p style="padding-bottom: 12px;" id="disclosure-copy-risk">Investments in the <span style="white-space: nowrap">T. Rowe Price</span> Retirement
                           Advisory Service&trade; are subject to the risks associated with investing in mutual funds, which may result
                           in loss of principal. <span style="white-space: nowrap">T. Rowe Price</span> does not guarantee the results of our investment
                           management, or that the objectives of the funds or portfolios will be met.</p>

                           <p style="padding-top: 0" id="disclosure-copy-discretionary-info">
                           The <span style="white-space: nowrap">T. Rowe Price</span> Retirement Advisory Service&trade; is a nondiscretionary financial planning and retirement
                           income planning service and a discretionary managed account program provided by <span style="white-space: nowrap">T. Rowe Price</span> Advisory
                           Services, Inc., a registered investment adviser under the Investment Advisers Act of 1940. Brokerage accounts for the Retirement Advisory Service are
                           provided by <span style="white-space: nowrap">T. Rowe Price</span> Investment Services, Inc., member FINRA/SIPC, and are carried by Pershing LLC, a
                           BNY Company, member NYSE/FINRA/SIPC, which acts as a clearing broker for <span style="white-space: nowrap">T. Rowe Price</span> Investment
                           Services, Inc. <span style="white-space: nowrap">T. Rowe Price</span> Advisory Services, Inc.
                           and <span style="white-space: nowrap">T. Rowe Price</span> Investment Services, Inc. are affiliated companies.
                           </p>

                           <p id="lrn-number" style="color: rgb(137, 137, 137); padding-top: 12px;">${lrnNumber}</p>`

export const Content = {
    emailInvitationError: {
        401: {
            headerText: 'Sorry, this invitation has expired.',
            text:
                'Please ask your co-client to resend the invitation. Then watch for another email with a new link so you can try again.',
            title: 'here',
            analyticsErrorName: 'Invitation Expired Error',
            pageName: 'Invite',
            id: 'invitation-expired'
        },

        403: {
            headerText: 'Ask your co-client to take this step.',
            text:
                'Please have your co-client reenroll in the service. Then they can resend the invitation so you can get started.',
            cardDataSubText: 'Watch for another email with a new, secure access link.',
            title: 'here',
            analyticsErrorName: 'Consent Expired Error',
            pageName: 'Invite',
            id: 'co-client-expired'
        },

        error: {
            headerText: 'Something went wrong.',
            text: 'Thanks for your patience. Please try refreshing your page or check back later.',
            cardDataSubText: errorText,
            analyticsErrorName: 'Invitation Error',
            pageName: 'Invite',
            id: 'invitation-error'
        },
    },
    HubPagesContent: {
        appNeeded: {
            content: `Use our appointment scheduler to choose a date and time convenient for you and your co-client, if applicable. If there are children or other
            loved ones you'd like to include on the call, we encourage their participation as well.`,
            subContent: `In addition to your financial goals, please be prepared to discuss expectations,
            concerns, and other income sources with your advisor. The more detailed the information you provide, the more personalized your recommendation will be.`,
        },
        appScheduled: {
            content: 'Thanks for scheduling a consultation with a financial advisor. We look forward to partnering with you!',
            subContent1: `In addition to your financial goals, please be prepared to discuss expectations,
            concerns, and other income sources with your advisor. The more detailed the information you provide, the more personalized your recommendation will be.`,
            subContent2: `In preparation for your appointment, a
            T. Rowe Price associate may call you for more information. Your prompt response will ensure that your advisor has your essential details. `
        },
    },
    PLDLPageContent: {
        financialPlan: {
            content: `Your custom plan includes advice from our team of experts on financial planning, asset allocation, and investment recommendations.
            Please carefully review your plan before consulting with your advisor.`,
            acceptTerms: `Accept the Terms of Service form before viewing your plan.`
        },
        planDocuments: {
            content: `A Certified Financial Planner has developed your personalized plan, based on what we’ve learned about you.
            Please carefully review your plan before consulting with your advisor.`,
            subContent: `Your Retirement Income Plan is your strategy for generating income from your investment assets and extending your portfolio over time.`
        },
    },
    FpsCardAction: {
        viewPlan: {
            headerText: 'View Latest Plan Documents',
            buttonId: 'view-expired-plan',
            mainButtonText: 'View Plan (PDF)',
            secondaryMainButtonText: 'View Retirement Income Plan (PDF)',
            tooltipTitle: 'Financial plan',
            tooltipText: 'Your financial plan includes our financial planning, asset allocation, and <span style="white-space: nowrap">T. Rowe Price</span> mutual fund' +
                ' and exchange-traded fund advice for your unique goals and needs.',
            secondaryTooltipTitle: 'Retirement Income Plan',
            secondaryTooltipText: 'Your Retirement Income Plan includes smart retirement income strategies for generating retirement income from your assets and extending' +
                ' your portfolio over time.',
            cardId: 'view-plan-tile',
        },
    },
    planBlockedAlert: {
        contentTitle: 'Your plan is trying to open.',
        contentText: 'Please use web browser notification to allow pop-ups on this page.'
    },
    schedulerBlockedAlert: {
        contentText: 'Your appointment scheduler is trying to open. Please use web browser notification to allow pop-ups on this page.'
    }
};

export const groupStatus = {
    PRE_CONSENT: 'PRCN',
    NOCONSENTEXPIREDENG: 'NoConsentExpiredEngagement',
    NOCONSENTEXPIREDENGCOCLIENT: 'NoConsentExpiredEngagementCoClient',
    CONSENT_GIVEN: 'CNGN',
    APPOINTMENT_NEEDED: 'APND',
    APPOINTMENT_SCHEDULED: 'APSC',
    FINANCIAL_ACCOUNTS: 'FPAC',
    PLAN_GENERATED_NOT_RELEASED: 'GNNR',
    PLAN_GENERATED_AND_RELEASED: 'GNRL',
    PLAN_DELIVERED: 'PLDL',
    PLAN_DELIVERED_EXPIRED_CLIENT: 'PLDLExpiredClient',
    PLAN_DELIVERED_EXPIRED_COCLIENT: 'PLDLExpiredCoClient',
    NO_DOCS_EXPIRED_CLIENT: 'ExpiredClient',
    CLIENT_EXPIRED_NO_PLAN_CO_CLIENT_LED_REENROLL: 'ExpiredClientCCLEng',
    NO_DOCS_EXPIRED_COCLIENT: 'ExpiredCoClient',
    NOT_CONSENTED_CLIENT: 'NotConsentedClient',
    NOT_CONSENTED_COCLIENT: 'NotConsentedCoClient',
    LIMBO: 'LIMBO',
    IMPLEMENTED: 'IPLD',
    FUNDING: 'FUND',
    COMPLETED: 'CMPD'

};


export const currentStatus = (status, isCoClient, archivedGroupSummary, planningGroup) => {
    const adjustedAppointmentStatus =
        status === groupStatus.APPOINTMENT_SCHEDULED ||
        status === groupStatus.PLAN_GENERATED_NOT_RELEASED;
    const adjustedPlanStatus =
        status === groupStatus.PLAN_DELIVERED || status === groupStatus.PLAN_GENERATED_AND_RELEASED;

    if (
        status === null &&
        planningGroup === null &&
        archivedGroupSummary &&
        archivedGroupSummary.archivedGroupsCount > 0
    ) {
        return groupStatus.LIMBO;
    }
    if (adjustedPlanStatus) {
        return groupStatus.PLAN_DELIVERED;
    }
    if (adjustedAppointmentStatus) {
        return groupStatus.APPOINTMENT_SCHEDULED;
    }
    if (status === null) {
        return isCoClient ? groupStatus.NOT_CONSENTED_COCLIENT : groupStatus.NOT_CONSENTED_CLIENT;
    }
    return status;
};

export const expiredStatusContent = (status, clientType, hasDocuments, coClientHasActiveConsent, hasCoClient) => {
    if (clientType === 'PRIMARY') {
        if (status === groupStatus.PRE_CONSENT) {
            return 'ExpiredClient'
        }
        if (hasCoClient && coClientHasActiveConsent) {
            return 'ExpiredClientCCLEng';
        }
        return status === groupStatus.PLAN_DELIVERED && hasDocuments ? 'PLDLExpiredClient' : 'ExpiredClient'
    }
    if (status === groupStatus.PRE_CONSENT) { return 'ExpiredClient' }
    return status === groupStatus.PLAN_DELIVERED && hasDocuments ? 'PLDLExpiredCoClient' : 'ExpiredCoClient'
};


export const retirementAdvisoryContent = {
    rasAccessChange: {
        heading: 'Your Retirement Advisory Service access has changed',
        content1:
            `This means that either you need to start a new financial plan because of a change by you or your co-client or that you are not continuing as a
            Retirement Advisory Service client at this time. Please contact your advisor at the phone number below if you are not clear about your status.`,
        content2:
            `We understand that life changes and want you to feel confident that as changes occur, we are by your side to help you achieve your best outcomes—for
            retirement, and for life.`,
    },
    startNewPlan: {
        heading: 'Start a new plan',
        content1:
            `Complete the questionnaire again so we can create a new plan that reflects your current situation. You can add a new co-client or accept an invitation to
            join another partner.`,
        content2: 'If you have any questions, please call us at 1-888-358-8490.',
    },
};

export const serviceInfo = [
    {
        bulletNum: 1,
        text: `Your financial plan (<strong>Plan</strong>) will consist of point-in-time planning, asset allocation, and T. Rowe Price mutual fund and exchange-traded fund advice
        based on the information you provide.`
    },
    {
        bulletNum: 2,
        text: `You are not obligated to accept the advice provided in the financial plan. If you implement the T. Rowe Price fund recommendations on your own, our affiliates will earn
        compensation through the management and/or other fees charged by these funds.`
    },
    {
        bulletNum: 3,
        text: `The financial plan is point-in-time and does not reflect any subsequent changes to your goals, risk tolerance, time horizon, or financial circumstances.`
    },
    {
        bulletNum: 4,
        text: `We will not invest or manage any of your assets unless you enroll in the discretionary management and ongoing advice portion of the Service, for which we charge a fee.
        If you enroll in the discretionary management and ongoing advice portion of the Service and meet certain eligibility requirements, your Retirement Income Plan will consist
        of an investment account withdrawal strategy during retirement and a Social Security claiming strategy.`
    },
    {
        bulletNum: 5,
        text: `You are required to agree to using electronic signatures and to enroll in electronic delivery of all documents and disclosures related to this Service.`
    },
    {
        bulletNum: 6,
        text: `Please refer to the <a href=${aemPdfLinks.formADVLink} target="_blank" rel="noopener noreferrer" style="text-decoration: underline;
        color: #086EA1">Retirement Advisory Service ADV Brochure</a> and the <a href=${aemPdfLinks.fpsClientAgreementLink} target="_blank"
        rel="noopener noreferrer" style="text-decoration: underline; color: #086EA1">Client Agreement and Planning Supplement (PDF)</a>
        for additional information.`
    }
];
